export default __webpack_public_path__ + "static/media/39.224fd67c.png";